import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {ISegmentViewModel} from "../../../services/booking/models/segment/segment-view-model.interface";
import {TicketSegmentDetailsComponent} from "./ticket-segment-details.component";
import {TicketSegmentPassengersComponent} from "./ticket-segment-passengers.component";
import {IBookingViewModel} from "../../../services/booking/models/booking-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";
import {getPageVerticalGap} from "../print-ticket.helpers";



interface TicketSegmentComponentProps {
    booking: IBookingViewModel;
    segment: ISegmentViewModel;
}
export const TicketSegmentComponent: React.FC<TicketSegmentComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        gap: getPageVerticalGap(theme),
        width: '100%'
    };

    return (
        <div style={styles}>
            <TicketSegmentDetailsComponent segment={props.segment}/>
            <TicketSegmentPassengersComponent segment={props.segment}/>
        </div>
    );
})